








































import NamedButton from "@/components/basic/buttons/NamedButton.vue";
import Vue from "vue";
import { Action } from "@/constants/ajax";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { SET_PROGRESS, SET_FORM_DATA, SET_GLOBAL_ERROR, SET_STEP, SET_LOCK } from "@/constants/mutation-types";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import { NavigationService } from "@/services/NavigationService";

export default Vue.extend({
  name: "waiting-for-picture",
  data() {
    return {
      status: true,
      forceLoopStop: false,
      isUploaded: false as boolean,
      TRANSLATION_KEY: "steps.WaitingForPicture",
    };
  },
  methods: {

    async checkWaitStatus() {
      try {
        while (this.status && !this.forceLoopStop) {
          const response = await this.$store.state.ajaxService.runAction(Action.CHECK_IF_DESKTOP_CAN_PROCEED, {});
          this.status = response.isDesktopWaiting;

          if (response.isDesktopWaiting === false) {
            this.forceLoopStop = true;

            if (response.dataContent) {
              this.$store.commit(SET_FORM_DATA, response.dataContent);
              const journeyId = response.dataContent.journeyId;
              const backendUrl = response.dataContent.backendUrl;
              const gbgToken = response.dataContent.gbgToken; 

              if (journeyId) {
                fetch(`${backendUrl}idscanenterprisesvc/journey/get?journeyId=${journeyId}`, {
                  headers: { Authorization: gbgToken },
                })
                  .then((response: any) => {
                    response.json().then((data: any) => {
                      this.$store.state.clientIdData = data.ProcessedDocuments;
                      this.$store.state.isSubheaderVisible = true;
                      const journeyStatus = data.HighLevelResult.toLowerCase();
                      this.$store.state.isLocked = "";

                      if (journeyStatus === "passed") {
                        this.$router.push({ name: "uploadSucceeded" });
                      } else {
                        this.$router.push({ name: "uploadFailed" });
                      }

                    });
                  })
                  .catch((err: any) => {
                    this.$router.push({ name: "uploadFailed" });
                  });
              }
            }
            // await this.$store.state.navigationService.goToRoute(response.next);
          }
          await UtilityHelper.sleep(5000);
        }
      } catch (e) {
        this.$store.commit(SET_GLOBAL_ERROR, e.message);

        if (e.restart) {
          this.$store.commit(SET_STEP, "restart");
          this.$store.state.ajaxService.restart();
          await this.$store.state.navigationService.goToRoute("restart").catch((e: any) => console.error(e));
        }

        UtilityHelper.sleep(1000).then(() => {
          this.$store.commit(SET_LOCK, false);
        });
      }
    },

    backStep() {
      this.$store.state.navigationService.goToRoute("mobileSms");
    },
  },
  mounted(): void {
    this.$store.commit(SET_PROGRESS, 3);
    this.checkWaitStatus();
  },
  beforeDestroy(): void {
    this.forceLoopStop = true;
  },
  components: {
    NamedButton,
    SubmitButton,
  },
});
